import { Link } from "react-router-dom";
import { SecretaryLayout } from "../Layout";
import { AddDoctorCard, DoctorsCard } from "../components";

export const AddDoctorsPage = () => {
  return (
    <SecretaryLayout>
      <div className="container-fluid">
        <div className="layout-specing">
          <div className="d-md-flex justify-content-between">
            <h5 className="mb-0">Agregar nuevo doctor</h5>
            <nav
              aria-label="breadcrumb"
              className="d-inline-block mt-4 mt-sm-0"
            >
              <ul className="breadcrumb bg-transparent rounded mb-0 p-0">
                <li className="breadcrumb-item">
                  <Link to="/secretary/dashboard">Gosafe</Link>
                </li>
                <li className="breadcrumb-item">
                  <Link to="/secretary/doctors">Doctores</Link>
                </li>
                <li className="breadcrumb-item active" aria-current="page">
                  Agregar doctor
                </li>
              </ul>
            </nav>
          </div>

          <div className="row">
            <div className="col-lg-8 mt-4">
              <AddDoctorCard />
            </div>

            <div className="col-lg-4 mt-4">
              <DoctorsCard />
            </div>
          </div>
        </div>
      </div>
    </SecretaryLayout>
  );
};
